import React, { useState, Fragment } from "react";
import {
    Row,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Button
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import { EventSettingForm } from './EventSettingForm';
export function AddEvent({ LoadData, propertyId, layoutItem }) {

    const [isAdd, setIsAdd] = useState(false);
    return (
        <Fragment>
            <div className="react-grid-item" style={{
                top: "10px",
                left: "10px",
                width: "296px",
                height: "230px", overflow: "overlay"
            }}
            >

                {isAdd ? (
                    <EventSettingForm
                        propertyId={propertyId}
                        layoutItem={layoutItem}
                        LoadData={LoadData}
                        setIsEdit={setIsAdd}></EventSettingForm>

                ) : (
                    <Card style={{ height: "-webkit-fill-available" }}>
                        <CardBody>
                            <Row>
                                <Colxx xxs="12" className="mb-5 mt-5" style={{ cursor: "pointer" }} onClick={() => setIsAdd(true)}>
                                    <div className="text-center">
                                        <h1 className="iconsminds-add" /><h2>Add </h2>
                                    </div>
                                </Colxx>
                            </Row>
                        </CardBody>
                    </Card>)}
            </div>


        </Fragment>
    );
};